import { useMemo } from 'react'

import { getApiOffersLoyaltyLevels, useQuery } from '@affiliate-cabinet/rest'
import { ResponseErrorInterface } from '@affiliate-cabinet/types'

import { LoyaltyLevelsDataType } from '../../lib/types'
import { getCurrentLevel } from '../../lib/utils/getCurrentLevel'
import { getLevelsWithRanges } from '../../lib/utils/getLevelsWithRanges'

export const useLoyaltyLevels = () => {
  const { data, error, isLoading, refetch } = useQuery<unknown, ResponseErrorInterface, LoyaltyLevelsDataType>(
    ['useLoyaltyLevels'],
    getApiOffersLoyaltyLevels,
    {
      staleTime: 600_000, // 10 minutes
    },
  )

  const currentFtd = useMemo(() => data?.current_ftd_count, [data?.current_ftd_count])
  const levels = useMemo(() => data?.levels || [], [data?.levels])
  const levelsWithRanges = useMemo(() => getLevelsWithRanges(levels), [levels])
  const currentLevel = useMemo(() => getCurrentLevel({ currentFtd, levels: levelsWithRanges }), [currentFtd, levelsWithRanges])

  return {
    currentFtd,
    currentLevel,
    data,
    error,
    levels,
    levelsWithRanges,
    loading: isLoading,
    refetch,
  }
}
